<template>
<v-expansion-panels v-model="showPanelRisposta">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default>
          Dettaglio invio FIle XML
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container fluid>
          <v-textarea
            v-if="esitoTrasmissione"
            name="input-7-1"
            filled
            label="Esito trasmissione"
            auto-grow
            rows="9"
            :value="esitoTrasmissione"
          ></v-textarea>
          <v-btn v-if="esitoTrasmissione" @click="onRichiediEsitoInvio">Esito invio</v-btn>
          <v-textarea
            v-if="esitoInvioRichiesto && esitoInvio"
            name="input-7-1"
            filled
            label="Esito invio"
            auto-grow
            rows="9"
            :value="esitoInvio"
          ></v-textarea>          
          <v-btn v-if="esitoInvio" @click="onRichiediDettaglioErrori">Dettaglio errori</v-btn>
          <v-textarea
            v-if="dettaglioErroriRichiesto && dettaglioErroriZip"
            name="input-7-1"
            filled
            label="Dettaglio errori"
            auto-grow
            rows="9"
            :value="dettaglioErroriZip"
          ></v-textarea>      
          <v-btn v-if="dettaglioErroriZip" @click="downloadErrori">Scarica il dettaglio Errori</v-btn>
          <!-- <v-btn  @click="downloadErrori_test">Scarica il dettaglio Errori test</v-btn> -->
          <v-btn v-if="dettaglioErrori" @click="onRichiediRicevutaPdf">Ricevuta pdf</v-btn>
          <v-textarea
            v-if="ricevutaPdfRichiesta && ricevutaPdf"
            name="input-7-1"
            filled
            label="Ricevuta pdf"
            auto-grow
            rows="9"
            :value="ricevutaPdf"
          ></v-textarea>
          <v-btn v-if="ricevutaPdf" @click="downloadPdf">Scarica Pdf Risposta</v-btn>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    props: {
      trasmissione: {
        type: Object
      },
      dettaglio: {
        type: Object
      },
      esito: {
        type: Object
      },
      ricevuta: {
        type: Object
      },
      showPanel: {
        type: Number,
        default: -1
      }
    },
    data() {
      return {
        esitoInvioRichiesto: false,
        dettaglioErroriRichiesto: false,
        ricevutaPdfRichiesta: false
      }
    },
    computed: {
      esitoTrasmissione() {
        return this.trasmissione ? JSON.stringify(this.trasmissione, null, 4) : ''
      },
      dettaglioErrori() {
        return this.dettaglio ? JSON.stringify(this.dettaglio, null, 4) : ''
      },
      esitoInvio() {
        return this.esito ? JSON.stringify(this.esito, null, 4) : ''
      },
      ricevutaPdf() {
        const ricevuta = JSON.parse(JSON.stringify(this.ricevuta))
        if (ricevuta && ricevuta.esitiPositivi) {
          delete ricevuta.esitiPositivi.dettagliEsito.pdf
          return JSON.stringify(ricevuta, null, 4)
        } else {
          return ''
        }
      },
      dettaglioErroriZip() {
        const dettaglio = JSON.parse(JSON.stringify(this.dettaglio))
        if (dettaglio && dettaglio.esitiPositivi) {
          delete dettaglio.esitiPositivi.dettagliEsito.csv
          return JSON.stringify(dettaglio, null, 4)
        } else {
          return ''
        }
      }, 
      showPanelRisposta() {
        return this.showPanel
      }
    },
    methods: {
      downloadPdf() {
        const linkSource = `data:application/pdf;base64,${this.ricevuta.esitiPositivi.dettagliEsito.pdf}`
        const downloadLink = document.createElement("a")
        const fileName = `DettagliEsito.pdf`

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },
      downloadErrori() {
        const linkSource = `data:application/zip;base64,${this.dettaglio.esitiPositivi.dettagliEsito.csv}`
        const downloadLink = document.createElement("a")
        const fileName = `DettagliErrori.zip`

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }, 
/*       downloadErrori_test() {
        const b64='inserire'
        const linkSource = `data:application/zip;base64,${b64}`
        const downloadLink = document.createElement("a")
        const fileName = `DettagliErrori.zip`

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },    */
      onRichiediEsitoInvio() {
        this.$emit('invio')
        this.esitoInvioRichiesto = true
      },
      onRichiediDettaglioErrori() {
        this.$emit('dettaglio')
        this.dettaglioErroriRichiesto = true
      },
      onRichiediRicevutaPdf() {
        this.$emit('ricevuta')
        this.ricevutaPdfRichiesta = true
      }
    }
  }
</script>
